import keyBy from 'lodash/keyBy';
import pluralize from 'pluralize';
import { camelCase, pascalCase } from '../helpers';

export function normalizeRelations(state, fields, inData = false) {
  if (inData) {
    return {
      ...state,
      data: {
        ...state.data,
        ...fields.reduce((prev, field) => {
          if (!state?.data?.[field]) return prev;

          return {
            ...prev,
            [field]: Array.isArray(state.data[field])
              ? state.data[field].map(x => x.id)
              : state.data[field].id
          };
        }, {})
      }
    };
  }

  return {
    ...state,
    ...fields.reduce((prev, field) => {
      if (!state?.[field]) return prev;

      return {
        ...prev,
        [field]: Array.isArray(state[field])
          ? state[field].map(x => x.id)
          : state[field].id
      };
    }, {})
  };
}

export function resolveRelations(state, fields, rootGetters, options = {}) {
  const { inData = false, inCart = false } = options;

  if (inData) {
    return {
      ...state,
      data: {
        ...(state?.data || {}),
        ...fields.reduce((prev, field) => {
          if (!state.data?.[field]) return prev;

          const getterPath = inCart
            ? `cart${pascalCase(field)}`
            : camelCase(pluralize(field));

          return {
            ...prev,
            [field]: Array.isArray(state.data[field])
              ? state.data[field].map(id => rootGetters[`${getterPath}/find`](id))
              : rootGetters[`${getterPath}/find`](state.data[field])
          };
        }, {})
      }
    };
  }

  return {
    ...state,
    ...fields.reduce((prev, field) => {
      if (!state?.[field]) return prev;

      const getterPath = inCart
        ? `cart${pascalCase(field)}`
        : camelCase(pluralize(field));

      return {
        ...prev,
        [field]: Array.isArray(state[field])
          ? state[field].map(id => rootGetters[`${getterPath}/find`](id))
          : rootGetters[`${getterPath}/find`](state[field])
      };
    }, {})
  };
}

export function addMany(state, items) {
  state.byId = {
    ...state.byId,
    ...keyBy(items, 'id')
  };

  state.allIds = [
    ...new Set([...state.allIds, ...items.map(i => i.id)])
  ];
}
